import { useEffect, useState } from 'react'
import { api } from '../../auth/api'

export default function ScanProgress({ jobId }) {
    const [job, setJob] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!jobId) return

        const fetchJob = async () => {
            try {
                const res = await api.get(`/lexis/scan/${jobId}`)
                const data = res.data
                setJob(data)
                setLoading(false)
                if (data.status === 'running') {
                    // poll every 2s
                } else {
                    clearInterval(timer)
                }
            } catch (e) {
                setLoading(false)
            }
        }

        fetchJob()
        const timer = setInterval(fetchJob, 2000)
        return () => clearInterval(timer)
    }, [jobId])

    if (loading || !job) return <p style={{ color: '#64748b' }}>Loading...</p>

    const total = job.total_files || 1
    const pct = Math.round(((job.processed_files || 0) / total) * 100)
    const filled = Math.round(pct / 5)
    const bar = '█'.repeat(filled) + '░'.repeat(20 - filled)

    const isDone = job.status === 'completed' || job.status === 'failed'
    const statusColor = job.status === 'completed' ? '#22c55e' : job.status === 'failed' ? '#ef4444' : '#d4af37'

    return (
        <div style={{
            background: 'rgba(30, 41, 59, 0.8)',
            borderRadius: '12px',
            padding: '24px',
            border: `1px solid ${statusColor}40`,
            marginTop: '20px',
        }}>
            <h3 style={{ margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px', color: statusColor }}>
                {isDone ? (job.status === 'completed' ? '✅' : '❌') : '🔄'}
                Scanning: {job.scan_path}
            </h3>
            <div style={{ fontSize: '14px', fontFamily: 'monospace', color: statusColor, marginBottom: '12px' }}>
                {bar} {pct}%
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', fontSize: '14px' }}>
                <div>
                    <span style={{ color: '#22c55e' }}>✔️ Processed:</span> {job.processed_files || 0}
                </div>
                <div>
                    <span style={{ color: '#ef4444' }}>❌ Failed:</span> {job.failed_files || 0}
                </div>
                <div>
                    <span style={{ color: '#f59e0b' }}>⏭️ Skipped:</span> {job.skipped_files || 0}
                </div>
            </div>
            {job.results?.length > 0 && (
                <div style={{ marginTop: '12px', fontSize: '12px', color: '#64748b' }}>
                    📄 Current: {job.results[job.results.length - 1]?.filename || 'Done'}
                    {job.started_at && (
                        <span style={{ marginLeft: '16px' }}>
                            🕐 Started: {new Date(job.started_at).toLocaleString()}
                        </span>
                    )}
                </div>
            )}
        </div>
    )
}